export default __webpack_public_path__ + "static/media/core-pending-image.9489770c.svg";